import React, { Component } from 'react';
import Select from 'react-select';
import { Row, Col, Popover, OverlayTrigger } from "react-bootstrap";

import DatePicker from 'react-date-picker';

import { CustomCard } from "../../components/Card/CustomCard";
import CustomModalPerfil from "../../components/Modal/CustomModalPerfil";
import CustomModalHome from "../../components/Modal/CustomModalHome";

import Line  from "../../components/Line/Line";

import { toast } from 'react-toastify';

import { consultaGeneral, consultaEstados, consultaCiudMunic, consultaParroquia, guardar,
         calculaEdad, ConsultaDisp } from '../../funciones/PefilFunction';
import { consultCarreras } from '../../funciones/MateriasFunction';

let fecha = new Date();
let usuario = "";
let tName = "";
let states = "";

class Perfil extends Component {
    state = {
        notificacionClass: "custom-alert-info",
        notificacionIcon: "fa fa-circle-o-notch fa-spin",
        notificacionText: "Verificando Información, espera por favor",
        notificacionText2: "",
        notificacionStyles: {
            fontSize:12, position:"absolute", top: 6
        },
        tituloVentana:  <React.Fragment>
                            Mi Perfil <span style={{fontSize: 13, color:"#000", position:"absolute", right: 25}}><i className="fa fa-spinner fa-spin"></i> Cargando Datos...</span>
                        </React.Fragment>,  
        cantErrores: "",
        selectNac: { value: 'V', label: 'V' },
        valorSex: { value: 'M', label: 'Masculino' },
        selectPais: { value: '', label: ' - Selecciona un Pais - ', status: "" },
        selectPaisDir: { value: '', label: ' - Selecciona un Pais - ', status: "" },
        selectPaisRepre: { value: '', label: ' - Selecciona un Pais - ', status: "" },
        selectEstado: { value: '', label: ' - Selecciona un Estado - ', status: "" },
        selectEstadoDir: { value: '', label: ' - Selecciona un Estado - ', status: "" },
        selectEstadoRepre: { value: '', label: ' - Selecciona un Estado - ', status: "" },
        selectCiudad: { value: '', label: ' - Selecciona una Ciudad - ', status: "" },
        selectCiudadDir: { value: '', label: ' - Selecciona una Ciudad - ', status: "" },
        selectCiudadRepre: { value: '', label: ' - Selecciona una Ciudad - ', status: "" },
        selectMunicipio: { value: '', label: ' - Selecciona un Municipio - ', status: "" },
        selectMunicipioDir: { value: '', label: ' - Selecciona un Municipio - ', status: "" },
        selectMunicipioRepre: { value: '', label: ' - Selecciona un Municipio - ', status: "" },
        selectParroquia: { value: '', label: ' - Selecciona una Parroquia - ', status: "" },
        selectParroquiaDir: { value: '', label: ' - Selecciona una Parroquia - ', status: "" },
        selectParroquiaRepre: { value: '', label: ' - Selecciona una Parroquia - ', status: "" },

        ced: { text:"Cédula de Identidad", status: "" },
        cedula: { text: "", status: "", disabled: "disabled" },
        pasaporte: { text: "", status: "", disabled: "disabled" },
        nombres: { text: "Nombres", status: "" },
        nombre1: { text: "", status: "", disabled: "disabled" },
        nombre2: { text: "", status: "", disabled: "disabled" },
        apellidos: { text: "Apellidos", status: "" },
        apellido1: { text: "", status: "", disabled: "disabled" },
        apellido2: { text: "", status: "", disabled: "disabled" },
        calle: { text: "", status: "", disabled: "disabled" },
        casa: { text: "", status: "", disabled: "disabled" },
        telefonos: { text: "Teléfonos", status: "" },
        tlf1: { text: "", status: "", disabled: "disabled" },
        tlf2: { text: "", status: "", disabled: "disabled" },
        tlf3: { text: "", status: "", disabled: "disabled" },

        cedRepre: { text:"Cédula de Identidad", status: "" },
        cedulaRepre: { text: "", status: "", disabled: "disabled" },
        pasaporteRepre: { text: "", status: "", disabled: "disabled" },
        nombresRepre: { text:"Nombres", status: "" },
        nombre1Repre: { text:"", status: "", disabled: "disabled" },
        nombre2Repre: { text:"", status: "", disabled: "disabled" },
        apellidosRepre: { text: "Apellidos", status: "" },
        apellido1Repre: { text: "", status: "", disabled: "disabled" },
        apellido2Repre: { text: "", status: "", disabled: "disabled" },
        calleRepre: { text: "", status: "", disabled: "disabled" },
        casaRepre: { text: "", status: "", disabled: "disabled" },
        emailRepre: { text: "", status: "", disabled: "disabled" },
        telefonosRepre: { text: "Teléfonos", status: "" },
        tlf1Repre: { text: "", status: "", disabled: "disabled" },
        tlf2Repre: { text: "", status: "", disabled: "disabled" },
        tlf3Repre: { text: "", status: "", disabled: "disabled" },

        paices: [{ value: '', label: ' - Cargando Lista - ' }],
        paicesDir: [{ value: '', label: ' - Cargando Lista - ' }],
        paicesRepre: [{ value: '', label: ' - Cargando Lista - ' }],
        estados: [],
        estadosDir: [],
        estadosRepre: [],
        ciudades: [],
        ciudadesDir: [],
        ciudadesRepre: [],
        municipios: [],
        municipiosDir: [],
        municipiosRepre: [],
        parroquias: [],
        parroquiasDir: [],
        parroquiasRepre: [],

        selectNacr: { value: 'V', label: 'V' },
        fecha: fecha,
        fechaStatus: "",
        fechaFormat: "",
        fechaTit: { text: "* Fecha de Nacimiento", status: "" },
        etnia: { text:"", status: "", disabled: "disabled" },
        edad:0,
        button: {
            Icon:"fa fa-save",
            Title:"Guardar",
            disabled: "disabled"
        },

        carreras: [],
        
        valorCarrera: { value: '', label: ' - Selecciona una Carrera - ' },
        openW:false,
        boton1: {
            icon: "fa fa-check",
            text: "Si"
        },
        /* openHome: true, */
        openHome: false,
    }


    constructor (props) {
        super (props);

        consultaGeneral((resp) => {
            tName = resp[2]
            usuario = resp[1]
            states = resp[3]
            this.setState(resp[0])
        })
        consultCarreras ((resp) => {
            this.setState({
                carreras: resp
            })

            setInterval(() => {
                this.setState({
                    valorCarrera: resp[0]
                })
            }, 200)
        })
    }
    
    valorSelectSex = (valorSex) => {this.setState({valorSex});}
    valorSelectNac = (selectNac) => {this.setState({selectNac});}
    valorCarrera = (valorCarrera) => {
        this.setState({valorCarrera});
    }

    valorSelectPais = (selectPais) => {
        this.setState({
            selectPais
        },() => {
            consultaEstados (selectPais.value, (resp) => {
                this.setState ({ estados: resp });
            })
        });
    }

    valorSelectPaisDir = (selectPaisDir) => {
        this.setState({
            selectPaisDir
        },() => {
            consultaEstados (selectPaisDir.value, (resp) => {
                this.setState ({ estadosDir: resp });
            })
        });
    }

    valorSelectPaisRepre = (selectPaisRepre) => {
        this.setState({
            selectPaisRepre
        },() => {
            consultaEstados (selectPaisRepre.value, (resp) => {
                this.setState ({ estadosRepre: resp });
            })
        });
    }


    valorSelectEstado = (selectEstado) => {
        this.setState({
            selectEstado,
            selectCiudad: { value: '', label: ' - Selecciona una Ciudad - ' },
            selectMunicipio: { value: '', label: ' - Selecciona un Municipio - ' },
            selectParroquia: { value: '', label: ' - Selecciona una Parroquia - ' },
            parroquias: [],
            ciudades: [{ value: '', label: ' - Cargando Ciudades - ' }],
            municipios: [{ value: '', label: ' - Cargando Municipios - ' }],
        },() => {
            consultaCiudMunic (selectEstado.value, (resp1) => {
                this.setState ({ ciudades: resp1 });
            },(resp2) => {
                this.setState ({ municipios: resp2 });
            })
        });
    }

    valorSelectEstadoDir = (selectEstadoDir) => {
        this.setState({
            selectEstadoDir,
            selectCiudadDir: { value: '', label: ' - Selecciona una Ciudad - ' },
            selectMunicipioDir: { value: '', label: ' - Selecciona un Municipio - ' },
            selectParroquiaDir: { value: '', label: ' - Selecciona una Parroquia - ' },
            parroquiasDir: [],
            ciudadesDir: [{ value: '', label: ' - Cargando Ciudades - ' }],
            municipiosDir: [{ value: '', label: ' - Cargando Municipios - ' }],
        },() => {
            consultaCiudMunic (selectEstadoDir.value, (resp1) => {
                this.setState ({ ciudadesDir: resp1 });
            },(resp2) => {
                this.setState ({ municipiosDir: resp2 });
            })
        });
    }

    valorSelectEstadoRepre = (selectEstadoRepre) => {
        this.setState({
            selectEstadoRepre,
            selectCiudadRepre: { value: '', label: ' - Selecciona una Ciudad - ' },
            selectMunicipioRepre: { value: '', label: ' - Selecciona un Municipio - ' },
            selectParroquiaRepre: { value: '', label: ' - Selecciona una Parroquia - ' },
            parroquiasRepre: [],
            ciudadesRepre: [{ value: '', label: ' - Cargando Ciudades - ' }],
            municipiosRepre: [{ value: '', label: ' - Cargando Municipios - ' }],
        },() => {
            consultaCiudMunic (selectEstadoRepre.value, (resp1) => {
                this.setState ({ ciudadesRepre: resp1 });
            }, (resp2) => {
                this.setState ({ municipiosRepre: resp2 });
            })
        });
    }
    

    valorSelectCiudad = (selectCiudad) => {this.setState({ selectCiudad });}
    valorSelectCiudadDir = (selectCiudadDir) => {this.setState({ selectCiudadDir });}
    valorSelectCiudadRepre = (selectCiudadRepre) => {this.setState({ selectCiudadRepre });}

    valorSelectMunicipio = (selectMunicipio) => {
        this.setState({
            selectMunicipio,
            selectParroquia: { value: '', label: ' - Selecciona una Parroquia - ' },
            parroquias: [{ value: '', label: ' - Cargando Parroquias - ' }]
        },() => {
            consultaParroquia (selectMunicipio.value, (resp) => {
                this.setState ({  parroquias: resp });
            })
        });
    }

    valorSelectMunicipioDir = (selectMunicipioDir) => {
        this.setState({
            selectMunicipioDir,
            selectParroquiaDir: { value: '', label: ' - Selecciona una Parroquia - ' },
            parroquiasDir: [{ value: '', label: ' - Cargando Parroquias - ' }]
        },() => {
            consultaParroquia (selectMunicipioDir.value, (resp) => {
                this.setState ({  parroquiasDir: resp });
            })
        });
    }

    valorSelectMunicipioRepre = (selectMunicipioRepre) => {
        this.setState({
            selectMunicipioRepre,
            selectParroquiaRepre: { value: '', label: ' - Selecciona una Parroquia - ' },
            parroquiasRepre: [{ value: '', label: ' - Cargando Parroquias - ' }]
        },() => {
            consultaParroquia (selectMunicipioRepre.value, (resp) => {
                this.setState ({ parroquiasRepre: resp });
            })
        });
    }
    
    valorSelectParroquia = (selectParroquia) => {this.setState({ selectParroquia });}
    valorSelectParroquiaDir = (selectParroquiaDir) => {this.setState({ selectParroquiaDir });}
    valorSelectParroquiaRepre = (selectParroquiaRepre) => {this.setState({ selectParroquiaRepre });}

    valorSelectNacr = (selectNacr) => {this.setState({ selectNacr });}

    cambiaFecha = (date) => {
        this.setState({
            fechaFormat: date,
            fecha: date,
            fechaStatus: ""
        },() => {
            calculaEdad(date, (resp) => {
                this.setState(resp[0]);
            })
        });
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:(event.target.value).toUpperCase(),
                status: ""
            },
        });
    };

    openWindow = () => (e) => {
        this.setState({
            openW: true
        })
    }

    closeWindow = () => (e) => {
        this.setState({
            openW: false
        })
    }

    cambiarDatos = () => (e) => {
        
        let { fechaFormat, tituloVentana, statusU, valorCarrera,
            selectNac, valorSex, selectPais, paices, selectEstado, estados, selectCiudad, ciudades,
            selectMunicipio, municipios, selectParroquia, parroquias, selectPaisDir, paicesDir, selectEstadoDir, estadosDir,
            selectCiudadDir, ciudadesDir, selectMunicipioDir, municipiosDir, selectParroquiaDir, parroquiasDir, fecha, etnia,
            paicesRepre, selectPaisRepre, selectEstadoRepre, estadosRepre, selectCiudadRepre, ciudadesRepre,
            selectNacr, selectMunicipioRepre, municipiosRepre, selectParroquiaRepre, parroquiasRepre,
            ced, cedula, pasaporte, nombres, nombre1, nombre2, apellidos, apellido1, apellido2, calle, casa, fechaStatus, fechaTit,
            edad, cedRepre, cedulaRepre, pasaporteRepre, nombresRepre, nombre1Repre, nombre2Repre, apellidosRepre, apellido1Repre,
            apellido2Repre, calleRepre, casaRepre, emailRepre, telefonos, tlf1,tlf2, tlf3, telefonosRepre, tlf1Repre, tlf2Repre, tlf3Repre
          } = this.state;

        const campos = { usuario, tName, fechaFormat, tituloVentana, statusU, valorCarrera,
                selectNac, valorSex, selectPais, paices, selectEstado, estados, selectCiudad, ciudades,
                selectMunicipio, municipios, selectParroquia, parroquias, selectPaisDir, paicesDir, selectEstadoDir, estadosDir,
                selectCiudadDir, ciudadesDir, selectMunicipioDir, municipiosDir, selectParroquiaDir, parroquiasDir, fecha, etnia,
                paicesRepre, selectPaisRepre, selectEstadoRepre, estadosRepre, selectCiudadRepre, ciudadesRepre,
                selectNacr, selectMunicipioRepre, municipiosRepre, selectParroquiaRepre, parroquiasRepre,
                ced, cedula, pasaporte, nombres, nombre1, nombre2, apellidos, apellido1, apellido2, calle, casa, fechaStatus, fechaTit,
                edad, cedRepre, cedulaRepre, pasaporteRepre, nombresRepre, nombre1Repre, nombre2Repre, apellidosRepre, apellido1Repre,
                apellido2Repre, calleRepre, casaRepre, emailRepre, telefonos, tlf1,tlf2, tlf3, telefonosRepre, tlf1Repre, tlf2Repre, tlf3Repre
        }
        this.setState({
            boton1: {
                icon:"fa fa-spinner fa-spin",
                text: "Espera"
            }
        })

        let respGuardar = (resp) => {
            let states = resp[0]
            let mensaje = resp[1]
            let errores = resp[2]
            let nameErrores = resp[3]
            let contentErr = []

            for (let i in nameErrores) {
                if (nameErrores[i] !== "") contentErr.push(
                    <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
                )
            }

            let help1 = (
                <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                    {contentErr}
                </Popover>
            )
            this.setState({
                button: {
                    Icon:"fa fa-spinner fa-spin",
                    Title:"Procesando..."
                },
                boton1: {
                    icon: "fa fa-check",
                    text: "Si"
                },
                openW: false
            })
            
            for (let i in states) { this.setState(states[i]) }

            let cerrar = () => {
                /* window.location.reload(); */
                consultaGeneral ((resp) => {
                    this.setState(resp[0])
                    toast.info(<div>
                                    <div>Los datos se han guardado exitósamente.</div>
                                    <div>Se actualizará cuando vuelvas a iniciar sesión</div>
                               </div>,{autoClose: 4000});
                    consultaGeneral ((resp) => { this.setState(resp[0]) })
                })
                
            }

            switch (mensaje[0].status) {
                case "error":
                    this.setState({
                        cantErrores:
                        <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={help1}>
                                 <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>,
                        button: {
                            Icon:"fa fa-save",
                            Title:"Guardar",
                        }
                    },() => {  
                        toast.error(mensaje[0].mensaje,{autoClose: 4000});
                    });
                    return null;
                case "warning":
                    toast.warning(mensaje[0].mensaje,{autoClose: 4000});
                    return null;
                case "info":
                    cerrar()
                    return null;
                default:
                    return null;
            }
        }
        guardar(campos, (resp) => {respGuardar(resp) })
    }

    showModal = () => {
        let { openW, boton1 } = this.state;
        let contenidoModal = () => (
            <React.Fragment>
                <div>¿Deseas realmente actualizar tu información?</div>
                <div style={{fontSize:10}}>Luego de actualizar tus datos debes esperar que sean validados, <strong>mientras tanto no podrás usar el sistema</strong></div>
            </React.Fragment>
        )

        return (
            <CustomModalPerfil
                isopen =  {openW}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal()}
                boton1 = {<React.Fragment><i className={boton1.icon}></i> {boton1.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                funcion1 = {this.cambiarDatos()}
                updState = {this.closeWindow()}/>
        );
    }

    showModalAviso = () => {
        let { openHome } = this.state;

        let contenidoModal = () => (
            <Row>
                <Col md = {12} align="center" className="text-danger"><strong style={{fontSize: 20}}><i className="fa fa-exclamation-triangle"></i> EVITA PERDER TIEMPO EN LA ADMISIÓN</strong></Col>
                <Col md = {12} className= "custom-mt-10" align="justify" style = {{padding: 30}}>
                    <div><strong>IMPORTANTE:</strong> Esta sección es solo para los estudiantes <strong className="text-danger">ESTUDIANTES REGULARES, PROFESORES Y PERSONAL</strong> que trabaja dentro de la institución</div>
                    <div className= "custom-mt-10"><strong>NO COMPLETES LOS DATOS</strong> si eres aspirante a admisión, debido a que esta acción puede retrasar tu ingreso y puedes perder tu cupo</div>
                    <div className= "custom-mt-10">Si deseas optar por el cupo debes ingresar a la sección <strong className = 'text-danger'>ADMISIÓN</strong> del menú de tu izquierda</div>
                    <div className= "custom-mt-10" align = "right"><small><strong>Si no eres estudiante, omite esta información</strong></small></div>
                </Col>
            </Row>
        )

        return (
            <CustomModalHome
                large = "medium"
                isopen =  {openHome}
                contenido = {contenidoModal()}
                cerrar = {() => this.setState({
                    openHome: false
                })}
            />
        )
    }

    busquedaDat = (tipo) => (e) => {
        if (e.target.value === "") return null;

        ConsultaDisp (this.state[tipo].text, tipo, (resp)=> {
            if(resp > 0){
                toast.error(`El documento ${(tipo).toUpperCase()} ya está registrado con otro usuario, por favor ingresa otro`,{autoClose: 4000});
                this.setState({
                    [tipo]: { text: "", status: "", disabled: "" }
                })
            }
        })
    }

    datRepre = () => {
        if (tName !== "EST") return null;

        let {
            paicesRepre, selectPaisRepre, selectEstadoRepre, estadosRepre, selectCiudadRepre, ciudadesRepre,
            selectNacr, selectMunicipioRepre, municipiosRepre, selectParroquiaRepre, parroquiasRepre,
            cedRepre, cedulaRepre, pasaporteRepre, nombresRepre, nombre1Repre, nombre2Repre, apellidosRepre, apellido1Repre,
            apellido2Repre, calleRepre, casaRepre, emailRepre, telefonosRepre, tlf1Repre, tlf2Repre, tlf3Repre
        } = this.state;

        const nac = [
            { value: 'V', label: 'V' },
            { value: 'E', label: 'E' },
        ];

        return (
            <React.Fragment>
                <Col md ={12} className="custom-mt-10"><div className="custom-alert-warning">Datos del Representante (Sólo si eres menor de edad)</div></Col>

                <Col md ={12} className="custom-mt-10"><div className={cedRepre.status}>{cedRepre.text}</div></Col>
                <Col md ={2} style={{marginTop:1}}>
                    <Select
                        isSearchable ={true}
                        value={selectNacr}
                        onChange={this.valorSelectNacr}
                        options={nac}
                    />
                </Col>
                <Col md ={6}>
                    <div className={cedulaRepre.status}>
                        <input type="text" value={cedulaRepre.text} disabled ={cedulaRepre.disabled} onChange={this.cambiaValor("cedulaRepre")} className="form-control" placeholder="DOCUMENTO DE IDENTIDAD"/>
                    </div>
                </Col>
                <Col md ={4}><input type="text" value={pasaporteRepre.text} disabled ={pasaporteRepre.disabled} onChange={this.cambiaValor("pasaporteRepre")} className="form-control" placeholder="PASAPORTE" title="Número de Pasaporte"/></Col>
                <Col md ={12} /* style={{marginTop:-10}} */><div className={nombresRepre.status}>{nombresRepre.text}</div></Col>
                <Col md ={6}>
                    <div className={nombre1Repre.status}>
                        <input type="text" value={nombre1Repre.text} disabled ={nombre1Repre.disabled} onChange={this.cambiaValor("nombre1Repre")} className="form-control" placeholder="INGRESA EL PRIMER NOMBRE"/>
                    </div>
                </Col>
                <Col md ={6}><input type="text" value={nombre2Repre.text} disabled ={nombre2Repre.disabled} onChange={this.cambiaValor("nombre2Repre")} className="form-control" placeholder="INGRESA EL SEGUNDO NOMBRE"/></Col>
                <Col md ={12}><div className={apellidosRepre.status}>{apellidosRepre.text}</div></Col>
                <Col md ={6}>
                    <div className={apellido1Repre.status}>
                        <input type="text" value={apellido1Repre.text} disabled ={apellido1Repre.disabled} onChange={this.cambiaValor("apellido1Repre")} className="form-control" placeholder="INGRESA EL PRIMER APELLIDO"/>
                    </div>
                </Col>
                <Col md ={6}><input type="text" value={apellido2Repre.text} disabled ={apellido2Repre.disabled} onChange={this.cambiaValor("apellido2Repre")} className="form-control" placeholder="INGRESA EL SEGUNDO APELLIDO"/></Col>

                <Col md ={12} className="custom-mt-10"><div className="custom-alert-warning">Dirección del Representante</div></Col>

                <Col md ={4} className="custom-mt-10">
                    <Select styles={selectPaisRepre.status} value={selectPaisRepre} onChange={this.valorSelectPaisRepre} options={paicesRepre} isSearchable ={true} />
                </Col>
                <Col md ={4} className="custom-mt-10">
                    <Select styles={selectEstadoRepre.status} value={selectEstadoRepre} onChange={this.valorSelectEstadoRepre} options={estadosRepre} isSearchable ={true} />
                </Col>
                <Col md ={4} className="custom-mt-10">
                    {/* <Select styles={selectCiudadRepre.status} value={selectCiudadRepre} onChange={this.valorSelectCiudadRepre} options={ciudadesRepre} isSearchable ={true} /> */}
                </Col>
                <Col md ={6} className="custom-mt-10">
                    <Select styles={selectMunicipioRepre.status} value={selectMunicipioRepre} onChange={this.valorSelectMunicipioRepre} options={municipiosRepre} isSearchable ={true} />
                </Col>
                <Col md ={6} className="custom-mt-10">
                    <Select styles={selectParroquiaRepre.status} value={selectParroquiaRepre} onChange={this.valorSelectParroquiaRepre} options={parroquiasRepre} isSearchable ={true} />
                </Col>

                <Col md ={6}className="custom-mt-10">
                    <div className={calleRepre.status}>
                        <input type="text" value={calleRepre.text} disabled ={calleRepre.disabled} onChange={this.cambiaValor("calleRepre")} className="form-control" placeholder="AV/CALLE/SECTOR"/>
                    </div>
                </Col>
                <Col md ={6}className="custom-mt-10">
                    <div className={casaRepre.status}>
                        <input type="text" value={casaRepre.text} disabled ={casaRepre.disabled} onChange={this.cambiaValor("casaRepre")} className="form-control" placeholder="EDF/CASA/QUINTA"/> 
                    </div>
                </Col>

                <Col md ={12} className="custom-mt-20">
                    <div className={emailRepre.status}>
                        <input type="text" value={emailRepre.text} disabled ={emailRepre.disabled} onChange={this.cambiaValor("emailRepre")} className="form-control" placeholder="CORREO ELECTRÓNICO"/>
                    </div>
                </Col>

                <Col md ={12}><div className={telefonosRepre.status}>{telefonosRepre.text}</div></Col>
                <Col md ={4}>
                    <div className={tlf1Repre.status}>
                        <input type="text" value={tlf1Repre.text} disabled ={tlf1Repre.disabled} onChange={this.cambiaValor("tlf1Repre")} className="form-control" placeholder="HABITACIÓN"/>
                    </div>
                </Col>
                <Col md ={4}>
                    <div className={tlf2Repre.status}>
                        <input type="text" value={tlf2Repre.text} disabled ={tlf2Repre.disabled} onChange={this.cambiaValor("tlf2Repre")} className="form-control" placeholder="CELULAR"/>
                    </div>
                </Col>
                <Col md ={4}>
                    <div className={tlf3Repre.status}>
                        <input type="text" value={tlf3Repre.text} disabled ={tlf3Repre.disabled} onChange={this.cambiaValor("tlf3Repre")} className="form-control" placeholder="OFICINA"/>
                    </div>
                </Col>
            </React.Fragment>
        )
    }

    datInsc = () => {
        if (tName !== "EST") return null;

        let { carreras, valorCarrera } = this.state;

        return (
            <Col md ={12} className="custom-mt-30"><div className="custom-alert-danger" style={{padding: 5}}>
                <Row>
                    <Col md ={6} style={{marginTop:10}}>Detalles de la Inscripción</Col>
                    <Col md ={6}>
                    <Select
                        isSearchable ={true}
                        value={valorCarrera}
                        onChange={this.valorCarrera}
                        options={carreras}
                    />
                    </Col>
                </Row>
            </div></Col>
        )
    }

    notifReg = () => {
        if (tName !== "EST") return null;
        if (states !== "1") return null;
        return (
            <div className="custom-alert-danger" style={{padding: 5, marginBottom: 10}} align="center">
                <div style={{fontSize:12}}>{this.state.notificacionText2}</div>
            </div>
        )
    }

    ayudaRepre = () => {
        if (tName !== "EST") return null;

        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <strong style={{color:"#CFAB75"}}>Acerca de los datos del representante</strong>
                    </Col>
                    <Col md={3} align="left" style={{fontSize:12}}>
                        <strong>Datos Generales</strong>
                    </Col>
                    <Col md={9} align="justify">
                        Estos datos solo son de caracter <strong>Obligatorio</strong> si eres menor de edad. En caso contrario omite esta información.
                        <br />
                        Para el llenado de dichos datos se deben seguir las mismas instrucciones de los datos personales.
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col md={12}>
                        <strong style={{color:"#A0555C"}}>Detalles de la Inscripción</strong>
                    </Col>
                    <Col md={3} align="left" style={{fontSize:12}}>
                        <strong>Carrera</strong>
                    </Col>
                    <Col md={9} align="justify">
                        <strong>Esta opción es sólo para los estudiantes. </strong>
                        Debes seleccionar la carrera que cursarás (Es importante que la información suministrada sea correcta, ya que será validada por Control de Estudios)
                    </Col>
                </Row>
                <hr/>
            </React.Fragment>
        )
    }

    ayudaRepreInfo = () => {
        if (tName !== "EST") return null;

        return (
            <React.Fragment>
                <hr/>
                <Row>
                    <Col md={3} align="left" style={{fontSize:12}}>
                        <strong>Importante</strong>
                    </Col>
                    <Col md={9} align="justify">
                        Para poder realizar la inscripción debes esperar que tus datos sean verificados. Luego de esto recibiras un <strong>Correo Electrónico </strong>
                        indicandote que tu información fue verificada.
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    botones = () => {
        let { button } = this.state;
        switch (states) {
            case "5":
                let help1 = (
                    <Popover bsSize="large" id="errbtn">
                        <div className="custom-alert-danger" align="center">Ya hiciste el proceso de admisión</div>
                        <div style={{marginTop: 5}} align="justify">
                            Debes culminar este proceso para poder actualizar la información de tu perfil
                        </div>
                    </Popover>
                )
                return (
                    <OverlayTrigger trigger="focus" placement="right" overlay={help1}>
                        <button className="btn btn-primary" disabled ={button.disabled} style={{borderWidth: 1}} title="Guardar Datos"><i className={button.Icon}></i> {button.Title}</button> 
                    </OverlayTrigger>
                )

            default:
                return (
                    <button  className="btn btn-primary" disabled ={button.disabled} onClick= {this.openWindow()} title="Guardar Datos" style={{borderWidth: 1}}><i className={button.Icon}></i> {button.Title}</button>
                )
        }
    }
    
    contenido = () => {
        let { cantErrores,
              selectNac, valorSex, selectPais, paices, selectEstado, estados, selectCiudad, ciudades,
              selectMunicipio, municipios, selectParroquia, parroquias, selectPaisDir, paicesDir, selectEstadoDir, estadosDir,
              selectCiudadDir, ciudadesDir, selectMunicipioDir, municipiosDir, selectParroquiaDir, parroquiasDir, fecha, etnia,
              ced, cedula, pasaporte, nombres, nombre1, nombre2, apellidos, apellido1, apellido2, calle, casa, fechaStatus, fechaTit,
              telefonos, tlf1,tlf2, tlf3
            } = this.state;

        const nac = [
            { value: 'V', label: 'V' },
            { value: 'E', label: 'E' },
        ];

        const Sex = [
            { value: 'M', label: 'Masculino' },
            { value: 'F', label: 'Femenino' },
        ];

        return (
            <Row style={{color:"#9a9a9a"}}>
                <Col md ={12}>{this.notifReg()}</Col>
                <Col md ={12}><div className="custom-alert-info" style={{padding: 5}}>
                    <Row>
                        <Col md ={7} style={{marginTop:10}}>Mis Datos</Col>
                        <Col md ={5}>
                        <Select
                            isSearchable ={true}
                            value={valorSex}
                            onChange={this.valorSelectSex}
                            options={Sex}
                        />
                        </Col>
                    </Row>
                </div></Col>
                <Col md ={12} className="custom-mt-10"><div className={ced.status}>{ced.text}</div></Col>
                <Col md ={2} style={{marginTop:1}}>
                    <Select
                        isSearchable ={true}
                        value={selectNac}
                        onChange={this.valorSelectNac}
                        options={nac}
                    />
                </Col>
                <Col md ={5}>
                    <div className={cedula.status}>
                        <input type="text" value={cedula.text} disabled ={cedula.disabled} onBlur={this.busquedaDat("cedula")} onChange={this.cambiaValor("cedula")} className="form-control" placeholder="* DOCUMENTO DE IDENTIDAD"/>
                    </div>
                </Col>
                <Col md ={5}>
                    <input type="text" value={pasaporte.text} disabled ={pasaporte.disabled} onBlur={this.busquedaDat("pasaporte")} onChange={this.cambiaValor("pasaporte")} className="form-control" placeholder="PASAPORTE" title="Número de Pasaporte"/>
                </Col>
                
                <Line color = "#E3E3E3"/>

                <Col md ={12}><div className={nombres.status}>{nombres.text}</div></Col>
                <Col md ={6}>
                    <div className={nombre1.status}>
                        <input type="text" value={nombre1.text} disabled ={nombre1.disabled} onChange={this.cambiaValor("nombre1")} className="form-control" placeholder="* INGRESA EL PRIMER NOMBRE"/>
                    </div>
                </Col>
                <Col md ={6}><input type="text" value={nombre2.text} disabled ={nombre2.disabled} onChange={this.cambiaValor("nombre2")} className="form-control" placeholder="INGRESA EL SEGUNDO NOMBRE"/></Col>
                <Col md ={12}><div className={apellidos.status}>{apellidos.text}</div></Col>
                <Col md ={6}>
                    <div className={apellido1.status}>
                        <input type="text" value={apellido1.text} disabled ={apellido1.disabled} onChange={this.cambiaValor("apellido1")} className="form-control" placeholder="* INGRESA EL PRIMER APELLIDO"/>
                    </div>
                </Col>
                <Col md ={6}><input type="text" value={apellido2.text} disabled ={apellido2.disabled} onChange={this.cambiaValor("apellido2")} className="form-control" placeholder="INGRESA EL SEGUNDO APELLIDO"/></Col>
                
                <Col md ={12} className="custom-mt-10"><div className="custom-alert-info">Datos de Nacimiento</div></Col>

                <Col md ={4} className="custom-mt-10">
                    <Select styles={selectPais.status} value={selectPais} onChange={this.valorSelectPais} options={paices} isSearchable ={true} />
                </Col>
                <Col md ={4} className="custom-mt-10">
                    <Select styles={selectEstado.status} value={selectEstado} onChange={this.valorSelectEstado} options={estados} isSearchable ={true} />
                </Col>
                <Col md ={4} className="custom-mt-10">
                    {/* <Select styles={selectCiudad.status} value={selectCiudad} onChange={this.valorSelectCiudad} options={ciudades} isSearchable ={true} /> */}
                </Col>
                <Col md ={6} /* style={{marginTop:-10}} */ className="custom-mt-10">
                    <Select styles={selectMunicipio.status} value={selectMunicipio} onChange={this.valorSelectMunicipio} options={municipios} isSearchable ={true} />
                </Col>
                <Col md ={6} /* style={{marginTop:-10}} */ className="custom-mt-10">
                    <Select styles={selectParroquia.status} value={selectParroquia} onChange={this.valorSelectParroquia} options={parroquias} isSearchable ={true} />
                </Col>

                <Col md ={6}><div className={fechaTit.status}>{fechaTit.text}</div></Col><Col md ={6}><div>Etnia</div></Col>
                <Col md ={6}>
                    <div className={fechaStatus.status}>
                        <DatePicker
                            clearIcon= {<i className="fa fa-times"></i>}
                            calendarIcon= {<i className="fa fa-calendar"></i>}
                            className="form-control"
                            onChange={this.cambiaFecha}
                            value={fecha}
                        />
                    </div>
                </Col>
                <Col md ={6}><input type="text" value={etnia.text} disabled ={etnia.disabled} onChange={this.cambiaValor("etnia")} className="form-control" placeholder="ETNIA"/></Col>
                
                <Col md ={12} className="custom-mt-10"><div className="custom-alert-info">Dirección de Habitación</div></Col>

                <Col md ={4} className="custom-mt-10">
                    <Select styles={selectPaisDir.status} value={selectPaisDir} onChange={this.valorSelectPaisDir} options={paicesDir} isSearchable ={true} />
                </Col>
                <Col md ={4} className="custom-mt-10">
                    <Select styles={selectEstadoDir.status} value={selectEstadoDir} onChange={this.valorSelectEstadoDir} options={estadosDir} isSearchable ={true} />
                </Col>
                <Col md ={4} className="custom-mt-10">
                    {/* <Select styles={selectCiudadDir.status} value={selectCiudadDir} onChange={this.valorSelectCiudadDir} options={ciudadesDir} isSearchable ={true} /> */}
                </Col>
                <Col md ={6} /* style={{marginTop:-10}} */ className="custom-mt-10">
                    <Select styles={selectMunicipioDir.status} value={selectMunicipioDir} onChange={this.valorSelectMunicipioDir} options={municipiosDir} isSearchable ={true} />
                </Col>
                <Col md ={6} /* style={{marginTop:-10}} */ className="custom-mt-10">
                    <Select styles={selectParroquiaDir.status} value={selectParroquiaDir} onChange={this.valorSelectParroquiaDir} options={parroquiasDir} isSearchable ={true} />
                </Col>

                <Col md ={6} className="custom-mt-10">
                    <div className={calle.status}>
                        <input type="text" value={calle.text} disabled ={calle.disabled} onChange={this.cambiaValor("calle")} className="form-control" placeholder="* AV/CALLE/SECTOR"/>
                    </div>
                </Col>
                <Col md ={6} className="custom-mt-10">
                    <div className={casa.status}>
                        <input type="text" value={casa.text} disabled ={casa.disabled} onChange={this.cambiaValor("casa")} className="form-control" placeholder="* EDF/CASA/QUINTA"/>
                    </div>
                </Col>

                <Col md ={12}><div className={telefonos.status}>{telefonos.text}</div></Col>
                <Col md ={4}>
                    <div className={tlf1.status}>
                        <input type="tel" value={tlf1.text} disabled ={tlf1.disabled} onChange={this.cambiaValor("tlf1")} className="form-control" placeholder="HABITACIÓN"/>
                    </div>
                </Col>
                <Col md ={4}>
                    <div className={tlf2.status}>
                        <input type="tel" value={tlf2.text} disabled ={tlf2.disabled} onChange={this.cambiaValor("tlf2")} className="form-control" placeholder="CELULAR"/>
                    </div>
                </Col>
                <Col md ={4}>
                    <div className={tlf3.status}>
                        <input type="tel" value={tlf3.text} disabled ={tlf3.disabled} onChange={this.cambiaValor("tlf3")} className="form-control" placeholder="OFICINA"/>
                    </div>
                </Col>
                {this.datRepre()}
                {this.datInsc()}
                <Col md ={8}><div className="text-danger">{ cantErrores }</div></Col>
                <Col md ={4} align="right" className="custom-mt-10" style={{marginBottom:2}}>
                    {this.botones()}
                </Col>
            </Row>
        );
    }

    ayuda = () => {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <strong style={{color:"#1f2f6e"}}>Acerca de los datos personales</strong>
                    </Col>
                    <Col md={3} align="left" style={{fontSize:12}}>
                        <strong>Cédula</strong>
                    </Col>
                    <Col md={9} align="justify">
                        En esta sección debes completar la información sin errores.
                        El campo Cédula debe ser escrito solo con numeros sin espacios ni puntos
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col md={3} align="left" style={{fontSize:12}}>
                        <strong>Nombres Apellidos</strong>
                    </Col>
                    <Col md={9} align="justify">
                        Completa estos campos tal y como aparece en tu documento de identidad (Partida de Nacimiento o Pasaporte)
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col md={12}>
                        <strong style={{color:"#1f2f6e"}}>Acerca de los datos de nacimiento</strong>
                    </Col>
                    <Col md={3} align="left" style={{fontSize:12}}>
                        <strong>Lugar de Nacimiento</strong>
                    </Col>
                    <Col md={9} align="justify">
                        En esta sección debes comenzar primero indicando el País | Estado | Ciudad | Municipio | Parroquia.
                        Luego debes completar la Avenida o Calle y el Num de Casa / Edificio / Quinta
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col md={12}>
                        <strong style={{color:"#1f2f6e"}}>Acerca de la dirección de habitación</strong>
                    </Col>
                    <Col md={3} align="left" style={{fontSize:12}}>
                        <strong>Lugar</strong>
                    </Col>
                    <Col md={9} align="justify">
                        De la misma forma que llenaste los datos de nacimiento, debes especificar tu dirección actual.
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col md={3} align="left" style={{fontSize:12}}>
                        <strong>Teléfonos</strong>
                    </Col>
                    <Col md={9} align="justify">
                        Completa los campos indicando el formato correcto para los números de telefono. Ej: <span style={{color:"#1f2f6e"}}>04140000000</span>. Solo indicando números
                    </Col>
                </Row>
                <hr/>
                {this.ayudaRepre()}
                <Row>
                    <Col md={12}>
                        <strong style={{color:"#A0555C"}}>Completando el Registro</strong>
                    </Col>
                    <Col md={3} align="left" style={{fontSize:12}}>
                        <strong>Guardar</strong>
                    </Col>
                    <Col md={9} align="justify">
                        Una vez llenado todos los campos es hora de culminar el proceso de registro. Para esto verifica que has colocado los datos de manera correcta
                        y presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-save"></i> Guardar</button>
                    </Col>
                </Row>
                {this.ayudaRepreInfo()}
            </React.Fragment>
        );
    }

    render() {
        let {tituloVentana, notificacionClass, notificacionText, notificacionIcon, notificacionStyles} = this.state;
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div className={notificacionClass} style={{padding:10}}>
                            <Row>
                                <Col md={11}>
                                <div>{notificacionText}</div>
                                </Col>
                                <Col md={1}><i className={notificacionIcon} style={notificacionStyles}></i></Col>
                            </Row>
                        </div>
                        <div style={{borderRadius: "4px 4px", marginTop:10}}>
                            <CustomCard
                                title={tituloVentana}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Datos Personales</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.showModal()}
                {this.showModalAviso()}
            </div>
        );
    }
}
 
export default Perfil;



// WEBPACK FOOTER //
// ./src/views/Perfil/Perfil.jsx